import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 16px;
  background: ${({ theme }) => theme.color.base.c1};
  border-radius: 5px;
  font-size: 14px;
  color: ${({ theme }) => theme.color.base.c8};
`
